import React from 'react';

type BadgeVariant =
  | 'active' |'paused' |'error' |'hot' |'warm' |'cold' |'buyer' |'new' |'contacted' |'draft' |'completed';

const variantMap: Record<BadgeVariant, string> = {
  active: 'bg-accent/15 text-accent border-accent/30',
  paused: 'bg-warning/15 text-warning border-warning/30',
  error: 'bg-danger/15 text-danger border-danger/30',
  hot: 'bg-danger/15 text-danger border-danger/30',
  warm: 'bg-warning/15 text-warning border-warning/30',
  cold: 'bg-muted text-muted-foreground border-border',
  buyer: 'bg-accent/15 text-accent border-accent/30',
  new: 'bg-primary/15 text-primary border-primary/30',
  contacted: 'bg-secondary text-muted-foreground border-border',
  draft: 'bg-muted text-muted-foreground border-border',
  completed: 'bg-accent/15 text-accent border-accent/30',
};

const labelMap: Record<BadgeVariant, string> = {
  active: 'Activo',
  paused: 'Pausado',
  error: 'Error',
  hot: 'Caliente',
  warm: 'Tibio',
  cold: 'Frío',
  buyer: 'Colaborador',
  new: 'Nuevo',
  contacted: 'Contactado',
  draft: 'Borrador',
  completed: 'Completada',
};

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
  size?: 'sm' | 'md';
}

export default function StatusBadge({
  variant,
  label,
  size = 'sm',
}: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 font-medium border rounded-full ${
        size === 'sm' ? 'text-2xs px-2 py-0.5' : 'text-xs px-2.5 py-1'
      } ${variantMap[variant]}`}
    >
      {variant === 'active' && (
        <span className="w-1.5 h-1.5 rounded-full bg-accent inline-block" />
      )}
      {label ?? labelMap[variant]}
    </span>
  );
}